/* ==========================================================================
   REWARD PROGRESS BAR — Vanilla JS Controller
   Shree Gifts N Crafts — Shopify Craft Theme
   No jQuery. No external dependencies. AJAX Cart API driven.
   ========================================================================== */

(function () {
  "use strict";

  /* ------------------------------------------------------------------------
     CONFIG — reward tiers in paise-free rupee integers (edit here only)
  ------------------------------------------------------------------------ */
  var REWARD_TIERS = [
    { threshold: 499, label: "499", type: "free_delivery", emoji: "🚚", title: "FREE DELIVERY", short: "FREE DELIVERY" },
    { threshold: 999, label: "999", type: "flat", value: 100, emoji: "🎉", title: "₹100 OFF", short: "₹100 OFF" },
    { threshold: 1499, label: "1499", type: "flat", value: 150, emoji: "🎊", title: "₹150 OFF", short: "₹150 OFF" },
    { threshold: 2500, label: "2500", type: "percent", value: 10, emoji: "🥳", title: "10% OFF", short: "10% OFF" },
    { threshold: 10000, label: "10000", type: "percent", value: 15, emoji: "🏆", title: "15% OFF", short: "15% OFF" }
  ];

  var STORAGE_KEY_PREFIX = "rt_unlocked_";
  var CURRENCY_SYMBOL = "₹";

  /* ------------------------------------------------------------------------
     STATE
  ------------------------------------------------------------------------ */
  var state = {
    cartTotal: 0,
    lastTotal: null, // used to detect newly crossed milestones
    collapsed: false,
    initialized: false
  };

  var els = {}; // cached DOM references
  var popupQueue = [];
  var popupShowing = false;
  var popupTimer = null;

  /* ------------------------------------------------------------------------
     UTILITIES
  ------------------------------------------------------------------------ */

  function formatMoney(rupees) {
    // Rounds to whole rupees for display (Shopify cart totals are in cents/paise)
    var n = Math.round(rupees);
    return CURRENCY_SYMBOL + n.toLocaleString("en-IN");
  }

  function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }

  function getSessionKey(tierIndex) {
    return STORAGE_KEY_PREFIX + tierIndex;
  }

  function hasSeenPopup(tierIndex) {
    try {
      return sessionStorage.getItem(getSessionKey(tierIndex)) === "1";
    } catch (e) {
      return false;
    }
  }

  function markPopupSeen(tierIndex) {
    try {
      sessionStorage.setItem(getSessionKey(tierIndex), "1");
    } catch (e) {
      /* sessionStorage unavailable (private mode) — fail silently */
    }
  }

  /* ------------------------------------------------------------------------
     TIER MATH — progress calculated BETWEEN each milestone, not 0–10000
  ------------------------------------------------------------------------ */

  function getTierProgress(total) {
    // Find current active tier (first not-yet-reached threshold)
    for (var i = 0; i < REWARD_TIERS.length; i++) {
      var tier = REWARD_TIERS[i];
      if (total < tier.threshold) {
        var prevThreshold = i === 0 ? 0 : REWARD_TIERS[i - 1].threshold;
        var range = tier.threshold - prevThreshold;
        var progressInRange = total - prevThreshold;
        var percent = clamp((progressInRange / range) * 100, 0, 100);
        return {
          index: i,
          tier: tier,
          percent: percent,
          remaining: tier.threshold - total,
          isFinal: false
        };
      }
    }
    // All tiers unlocked
    return {
      index: REWARD_TIERS.length - 1,
      tier: REWARD_TIERS[REWARD_TIERS.length - 1],
      percent: 100,
      remaining: 0,
      isFinal: true
    };
  }

  function getUnlockedTiers(total) {
    var unlocked = [];
    for (var i = 0; i < REWARD_TIERS.length; i++) {
      if (total >= REWARD_TIERS[i].threshold) unlocked.push(i);
    }
    return unlocked;
  }

  /* ------------------------------------------------------------------------
     DOM BUILD — creates the tracker markup once and caches references
  ------------------------------------------------------------------------ */

  function buildDOM() {
    var wrapper = document.getElementById("rt-reward-tracker");
    if (!wrapper) return false;

    els.wrapper = wrapper;
    els.card = wrapper.querySelector(".rt-card");
    els.messageRow = wrapper.querySelector(".rt-message-row");
    els.message = wrapper.querySelector(".rt-message");
    els.toggleBtn = wrapper.querySelector(".rt-toggle-btn");
    els.collapsible = wrapper.querySelector(".rt-collapsible-inner");
    els.progressTrack = wrapper.querySelector(".rt-progress-track");
    els.progressSegmentFills = null;
    els.timeline = wrapper.querySelector(".rt-timeline");
    els.emptyState = wrapper.querySelector(".rt-empty-state");
    els.mainContent = wrapper.querySelector(".rt-main-content");
    els.finalState = wrapper.querySelector(".rt-final-state");

    els.popupOverlay = document.getElementById("rt-popup-overlay");
    els.popup = document.getElementById("rt-popup");
    els.popupEmoji = document.getElementById("rt-popup-emoji");
    els.popupReward = document.getElementById("rt-popup-reward");
    els.popupNext = document.getElementById("rt-popup-next");
    els.popupClose = document.getElementById("rt-popup-close");

    return true;
  }

  function buildTimelineMarkup() {
    if (!els.timeline) return;
    var html = "";
    for (var i = 0; i < REWARD_TIERS.length; i++) {
      var tier = REWARD_TIERS[i];
      html +=
        '<div class="rt-milestone" data-tier-index="' + i + '" role="listitem" aria-label="' +
        tier.title + " at " + CURRENCY_SYMBOL + tier.threshold + '">' +
        '<div class="rt-milestone-dot">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        "</div>" +
        '<span class="rt-milestone-label">' + CURRENCY_SYMBOL + tier.label + "</span>" +
        "</div>";
    }
    els.timeline.innerHTML = html;
  }
  function buildProgressSegments() {
    if (!els.progressTrack) return;
    var html = "";
    for (var i = 0; i < REWARD_TIERS.length; i++) {
      html +=
        '<div class="rt-progress-segment" data-segment-index="' + i + '">' +
        '<div class="rt-progress-segment-fill"></div>' +
        "</div>";
    }
    els.progressTrack.innerHTML = html;
    els.progressSegmentFills = els.progressTrack.querySelectorAll(".rt-progress-segment-fill");
  }

  /* ------------------------------------------------------------------------
     RENDER — updates UI based on current cart total
  ------------------------------------------------------------------------ */

  function render(total) {
    state.cartTotal = total;

    if (total <= 0) {
      renderEmptyState();
      return;
    }

    if (els.emptyState) els.emptyState.style.display = "none";
    if (els.mainContent) els.mainContent.style.display = "";

    var progress = getTierProgress(total);

    if (progress.isFinal) {
      renderFinalState();
    } else {
      renderActiveState(progress);
    }

    updateTimeline(total, progress);
    updateProgressBar(total);
    ensureVisible();
  }

  function renderEmptyState() {
    if (els.mainContent) els.mainContent.style.display = "none";
    if (els.finalState) els.finalState.style.display = "none";
    if (els.emptyState) els.emptyState.style.display = "flex";
    ensureVisible();
  }

  function renderActiveState(progress) {
    if (els.finalState) els.finalState.style.display = "none";
    if (els.mainContent) els.mainContent.style.display = "";

    var tier = progress.tier;
    var remainingText = formatMoney(progress.remaining);
    var msg = "";

    if (progress.index === 0) {
      msg =
        '🎁 Add <span class="rt-amount">' + remainingText + "</span> more to unlock " +
        "<strong>" + tier.short + "</strong>";
    } else {
      var prevTier = REWARD_TIERS[progress.index - 1];
      msg =
        '🎁 Add <span class="rt-amount">' + remainingText + "</span> more to unlock " +
        "<strong>" + tier.short + "</strong>" +
        '<span class="rt-sub">' + prevTier.emoji + " " + prevTier.short + " already unlocked</span>";
    }

    if (els.message) els.message.innerHTML = msg;
  }

  function renderFinalState() {
    if (els.mainContent) els.mainContent.style.display = "none";
    if (els.finalState) {
      els.finalState.style.display = "block";
      els.finalState.innerHTML =
        '<div class="rt-final-title">🏆 Amazing! You\'ve unlocked every reward.</div>' +
        '<div class="rt-final-list">' +
        REWARD_TIERS.map(function (t) {
          return '<span class="rt-final-chip">' + t.emoji + " " + t.short + " ✓</span>";
        }).join("") +
        "</div>";
    }
  }

function updateProgressBar(total) {
    if (!els.progressSegmentFills || els.progressSegmentFills.length === 0) {
      console.warn("[Reward Tracker] Progress segments not built yet.");
      return;
    }
    els.progressSegmentFills.forEach(function (fillEl, i) {
      var tier = REWARD_TIERS[i];
      var prevThreshold = i === 0 ? 0 : REWARD_TIERS[i - 1].threshold;
      var range = tier.threshold - prevThreshold;
      var pct;

      if (total >= tier.threshold) {
        pct = 100; // this reward already fully unlocked
      } else if (total <= prevThreshold) {
        pct = 0; // hasn't reached this segment yet
      } else {
        pct = clamp(((total - prevThreshold) / range) * 100, 0, 100);
      }

      fillEl.style.setProperty("width", pct + "%", "important");
    });
  }
  function updateTimeline(total, progress) {
    if (!els.timeline) return;
    var nodes = els.timeline.querySelectorAll(".rt-milestone");
    nodes.forEach(function (node, i) {
      node.classList.remove("rt-completed", "rt-current", "rt-future");
      if (total >= REWARD_TIERS[i].threshold) {
        node.classList.add("rt-completed");
      } else if (i === progress.index) {
        node.classList.add("rt-current");
      } else {
        node.classList.add("rt-future");
      }
    });
  }

  function ensureVisible() {
    if (els.wrapper && !els.wrapper.classList.contains("rt-visible")) {
      requestAnimationFrame(function () {
        els.wrapper.classList.add("rt-visible");
      });
    }
  }

  /* ------------------------------------------------------------------------
     COLLAPSE / EXPAND TOGGLE
  ------------------------------------------------------------------------ */

  function bindToggle() {
    if (!els.toggleBtn) return;
    els.toggleBtn.addEventListener("click", function () {
      state.collapsed = !state.collapsed;
      els.wrapper.classList.toggle("rt-collapsed", state.collapsed);
      els.toggleBtn.setAttribute("aria-expanded", String(!state.collapsed));
    });
  }

  /* ------------------------------------------------------------------------
     MILESTONE DETECTION — fires when a new tier is crossed
  ------------------------------------------------------------------------ */

  function detectNewMilestones(prevTotal, newTotal) {
    if (prevTotal === null) {
      // First load: silently mark any already-unlocked tiers as "seen"
      // so refreshing an existing cart above a threshold doesn't pop.
      var alreadyUnlocked = getUnlockedTiers(newTotal);
      alreadyUnlocked.forEach(function (i) {
        if (!hasSeenPopup(i)) markPopupSeen(i);
      });
      return;
    }

    if (newTotal <= prevTotal) return; // only fire on increase

    for (var i = 0; i < REWARD_TIERS.length; i++) {
      var tier = REWARD_TIERS[i];
      var justCrossed = prevTotal < tier.threshold && newTotal >= tier.threshold;
      if (justCrossed && !hasSeenPopup(i)) {
        markPopupSeen(i);
        queuePopup(i, newTotal);
      }
    }
  }

  /* ------------------------------------------------------------------------
     POPUP — celebration on unlock
  ------------------------------------------------------------------------ */

  function queuePopup(tierIndex, totalAtUnlock) {
    popupQueue.push({ tierIndex: tierIndex, total: totalAtUnlock });
    if (!popupShowing) showNextPopup();
  }

  function showNextPopup() {
    if (popupQueue.length === 0) {
      popupShowing = false;
      return;
    }
    popupShowing = true;
    var item = popupQueue.shift();
    var tier = REWARD_TIERS[item.tierIndex];
    var progress = getTierProgress(item.total);

    if (els.popupEmoji) els.popupEmoji.textContent = tier.emoji;
    if (els.popupReward) els.popupReward.textContent = tier.title;

    if (progress.isFinal) {
      if (els.popupNext) {
        els.popupNext.innerHTML = "You've unlocked every reward available. Thank you for shopping with us!";
      }
    } else if (els.popupNext) {
      els.popupNext.innerHTML =
        "Keep shopping! Only <span class=\"rt-amount\">" +
        formatMoney(progress.remaining) +
        "</span> more for " + progress.tier.short + ".";
    }

    openPopup();
    fireConfetti();

    clearTimeout(popupTimer);
    popupTimer = setTimeout(closePopup, 4000);
  }

  function openPopup() {
    if (!els.popupOverlay) return;
    els.popupOverlay.classList.add("rt-show");
    els.popupOverlay.setAttribute("aria-hidden", "false");
    if (els.popupClose) els.popupClose.focus();
    document.addEventListener("keydown", handlePopupKeydown);
  }

  function closePopup() {
    if (!els.popupOverlay) return;
    clearTimeout(popupTimer);
    els.popupOverlay.classList.remove("rt-show");
    els.popupOverlay.setAttribute("aria-hidden", "true");
    document.removeEventListener("keydown", handlePopupKeydown);
    setTimeout(function () {
      popupShowing = false;
      if (popupQueue.length > 0) showNextPopup();
    }, 350);
  }

  function handlePopupKeydown(e) {
    if (e.key === "Escape") closePopup();
  }

  function bindPopupEvents() {
    if (els.popupClose) els.popupClose.addEventListener("click", closePopup);
    if (els.popupOverlay) {
      els.popupOverlay.addEventListener("click", function (e) {
        if (e.target === els.popupOverlay) closePopup();
      });
    }
  }

  /* ------------------------------------------------------------------------
     CONFETTI — lightweight pure JS canvas confetti (no libraries)
  ------------------------------------------------------------------------ */

  var confettiCanvas, confettiCtx, confettiParticles = [], confettiRAF = null;

  function ensureConfettiCanvas() {
    if (confettiCanvas) return;
    confettiCanvas = document.createElement("canvas");
    confettiCanvas.id = "rt-confetti-canvas";
    confettiCanvas.setAttribute("aria-hidden", "true");
    document.body.appendChild(confettiCanvas);
    confettiCtx = confettiCanvas.getContext("2d");
    resizeConfettiCanvas();
    window.addEventListener("resize", resizeConfettiCanvas);
  }

  function resizeConfettiCanvas() {
    if (!confettiCanvas) return;
    confettiCanvas.width = window.innerWidth;
    confettiCanvas.height = window.innerHeight;
  }

  var CONFETTI_COLORS = ["#4caf7d", "#2e7d4f", "#e0b64f", "#6b4a33", "#faf6ef"];

  function fireConfetti() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return; // respect accessibility preference
    }

    ensureConfettiCanvas();
    var count = 60;
    var originX = window.innerWidth / 2;
    var originY = window.innerHeight - 120;

    for (var i = 0; i < count; i++) {
      confettiParticles.push({
        x: originX + (Math.random() - 0.5) * 120,
        y: originY,
        vx: (Math.random() - 0.5) * 8,
        vy: -(Math.random() * 9 + 4),
        size: Math.random() * 6 + 4,
        color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
        rotation: Math.random() * 360,
        rotationSpeed: (Math.random() - 0.5) * 12,
        gravity: 0.28,
        life: 0,
        maxLife: 90 + Math.random() * 30
      });
    }

    if (!confettiRAF) confettiRAF = requestAnimationFrame(animateConfetti);
  }

  function animateConfetti() {
    if (!confettiCtx) return;
    confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);

    confettiParticles = confettiParticles.filter(function (p) {
      p.vy += p.gravity;
      p.x += p.vx;
      p.y += p.vy;
      p.rotation += p.rotationSpeed;
      p.life++;

      var alpha = clamp(1 - p.life / p.maxLife, 0, 1);
      confettiCtx.save();
      confettiCtx.translate(p.x, p.y);
      confettiCtx.rotate((p.rotation * Math.PI) / 180);
      confettiCtx.globalAlpha = alpha;
      confettiCtx.fillStyle = p.color;
      confettiCtx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
      confettiCtx.restore();

      return p.life < p.maxLife && p.y < confettiCanvas.height + 50;
    });

    if (confettiParticles.length > 0) {
      confettiRAF = requestAnimationFrame(animateConfetti);
    } else {
      confettiRAF = null;
      confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
    }
  }

  /* ------------------------------------------------------------------------
     CART FETCH — always reads latest truth from /cart.js
  ------------------------------------------------------------------------ */

  function fetchCart() {
    return fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Cart fetch failed: " + res.status);
        return res.json();
      })
      .catch(function (err) {
        console.error("[Reward Tracker] Failed to fetch cart:", err);
        return null;
      });
  }

  function refreshFromCart(cart) {
    if (!cart) return;
    var totalRupees = cart.total_price / 100; // Shopify returns cents/paise
    var prevTotal = state.lastTotal;

    detectNewMilestones(prevTotal, totalRupees);
    render(totalRupees);

    state.lastTotal = totalRupees;
  }

  function pollCartAndRender() {
    fetchCart().then(refreshFromCart);
  }

  /* ------------------------------------------------------------------------
     EVENT LISTENERS — catches AJAX cart / drawer cart / theme events
     Covers common Shopify theme event patterns without assuming a specific
     cart framework, plus a safety-net interval poll.
  ------------------------------------------------------------------------ */

  function bindCartEvents() {
    // Standard document-level custom events used by many Shopify themes
    var eventNames = [
      "cart:updated",
      "cart:refresh",
      "cart:build",
      "cart:change",
      "ajaxProduct:added",
      "product:added",
      "quantity:change"
    ];

    eventNames.forEach(function (name) {
      document.addEventListener(name, pollCartAndRender);
    });

    // Intercept fetch calls to Shopify cart endpoints (add/change/update/clear)
    // so the tracker reacts instantly regardless of theme-specific events.
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = args[0] instanceof Request ? args[0].url : args[0];
      var result = originalFetch.apply(this, args);

      if (typeof url === "string" && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        result
          .then(function (res) {
            // Small delay to ensure Shopify has fully committed the cart state
            setTimeout(pollCartAndRender, 150);
            return res;
          })
          .catch(function () {
            /* ignore — original caller still handles its own error */
          });
      }
      return result;
    };

    // Fallback: lightweight interval poll (covers form-submits/non-fetch flows)
    setInterval(pollCartAndRender, 4000);

    // Also refresh when tab regains focus (cart may have changed in another tab)
    window.addEventListener("focus", pollCartAndRender);
  }

  /* ------------------------------------------------------------------------
     CHECKOUT EXCLUSION — never render on checkout pages
  ------------------------------------------------------------------------ */

  function isCheckoutPage() {
    return /\/checkout/.test(window.location.pathname) || window.Shopify && window.Shopify.designMode === undefined && document.body.classList.contains("template-checkout");
  }

  /* ------------------------------------------------------------------------
     INIT
  ------------------------------------------------------------------------ */

  function init() {
    if (state.initialized) return;
    if (isCheckoutPage()) return;
    if (!buildDOM()) return;

    state.initialized = true;

    buildTimelineMarkup();
    buildProgressSegments();
    bindToggle();
    bindPopupEvents();

    pollCartAndRender();
    bindCartEvents();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Expose a small public API for theme editor / debugging use
  window.RewardTracker = {
    refresh: pollCartAndRender,
    getState: function () {
      return { total: state.cartTotal, collapsed: state.collapsed };
    }
  };
})();